import { Container } from '@mui/material';
import { EditExercise } from 'components/templates';

export const EditExerciseView = () => {
  return (
    <Container>
      <EditExercise />
    </Container>
  );
};
